import React from "react";

const Loader = (props) => {
  const APP_PATH = process.env.REACT_APP_CONTEXT_PATH;
  return (
    <div
      className="sim-chart loader-rotate"
      style={{ display: "flex", justifyContent: "center" }}
    >
      <img
        src={`${APP_PATH}/loader.svg`}
        style={props.loaderStyle}
        alt="LOADING"
      />
    </div>
  );
};

export default Loader;
